import { render, staticRenderFns } from "./nowDistributorBlack.vue?vue&type=template&id=1bbbd89f&scoped=true"
import script from "./nowDistributorBlack.vue?vue&type=script&lang=js"
export * from "./nowDistributorBlack.vue?vue&type=script&lang=js"
import style0 from "./nowDistributorBlack.vue?vue&type=style&index=0&id=1bbbd89f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbbd89f",
  null
  
)

export default component.exports